// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/ticker_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { State } from "./common_pb";
import { file_api_v1_common } from "./common_pb";
import type { Memo } from "./memo_service_pb";
import { file_api_v1_memo_service } from "./memo_service_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/ticker_service.proto.
 */
export const file_api_v1_ticker_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_v1_common, file_api_v1_memo_service, file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask]);

/**
 * Ticker represents a stock ticker symbol with company information
 *
 * @generated from message journal.api.v1.Ticker
 */
export type Ticker = Message<"journal.api.v1.Ticker"> & {
  /**
   * The unique ID of the ticker
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The resource name of the ticker.
   * Format: tickers/{symbol}
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * The stock symbol (e.g., TSLA, AAPL, GOOGL)
   *
   * @generated from field: string symbol = 3;
   */
  symbol: string;

  /**
   * The company name
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * The exchange where the stock is listed (e.g., NASDAQ, NYSE)
   *
   * @generated from field: string exchange = 5;
   */
  exchange: string;

  /**
   * The sector (e.g., Technology, Healthcare)
   *
   * @generated from field: string sector = 6;
   */
  sector: string;

  /**
   * The industry (e.g., Auto Manufacturers)
   *
   * @generated from field: string industry = 7;
   */
  industry: string;

  /**
   * The company logo URL
   *
   * @generated from field: string logo_url = 8;
   */
  logoUrl: string;

  /**
   * The company description
   *
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * The company website
   *
   * @generated from field: string website = 10;
   */
  website: string;

  /**
   * The current stock price
   *
   * @generated from field: double price = 11;
   */
  price: number;

  /**
   * The price change (absolute value)
   *
   * @generated from field: double changes = 12;
   */
  changes: number;

  /**
   * The price change percentage
   *
   * @generated from field: double changes_percentage = 13;
   */
  changesPercentage: number;

  /**
   * The currency (e.g., USD, EUR)
   *
   * @generated from field: string currency = 14;
   */
  currency: string;

  /**
   * The create time of the ticker.
   *
   * @generated from field: int64 create_time = 15;
   */
  createTime: bigint;

  /**
   * The update time of the ticker.
   *
   * @generated from field: int64 update_time = 16;
   */
  updateTime: bigint;

  /**
   * The state of the ticker.
   *
   * @generated from field: journal.api.v1.State state = 17;
   */
  state: State;

  /**
   * The watchlist status of the ticker (researching | rejected | holding | sold)
   *
   * @generated from field: string status = 18;
   */
  status: string;

  /**
   * The last associated memo summary (optional)
   *
   * @generated from field: journal.api.v1.LastMemoInfo last_memo = 19;
   */
  lastMemo?: LastMemoInfo;

  /**
   * Valuation data (from user_valuation_config)
   *
   * @generated from field: double ideal_buy_price = 20;
   */
  idealBuyPrice: number;

  /**
   * @generated from field: double ideal_sell_price = 21;
   */
  idealSellPrice: number;

  /**
   * @generated from field: double reasonable_price = 22;
   */
  reasonablePrice: number;

  /**
   * calculated: ((current - buy) / buy) * 100
   *
   * @generated from field: double percent_to_buy = 23;
   */
  percentToBuy: number;

  /**
   * calculated: ((current - sell) / sell) * 100
   *
   * @generated from field: double percent_to_sell = 24;
   */
  percentToSell: number;

  /**
   * calculated: min(|% to buy|, |% to sell|)
   *
   * @generated from field: double actionability_score = 25;
   */
  actionabilityScore: number;
};

/**
 * Describes the message journal.api.v1.Ticker.
 * Use `create(TickerSchema)` to create a new message.
 */
export const TickerSchema: GenMessage<Ticker> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 0);

/**
 * @generated from message journal.api.v1.CreateTickerRequest
 */
export type CreateTickerRequest = Message<"journal.api.v1.CreateTickerRequest"> & {
  /**
   * The ticker to create.
   *
   * @generated from field: journal.api.v1.Ticker ticker = 1;
   */
  ticker?: Ticker;
};

/**
 * Describes the message journal.api.v1.CreateTickerRequest.
 * Use `create(CreateTickerRequestSchema)` to create a new message.
 */
export const CreateTickerRequestSchema: GenMessage<CreateTickerRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 1);

/**
 * @generated from message journal.api.v1.ListTickersRequest
 */
export type ListTickersRequest = Message<"journal.api.v1.ListTickersRequest"> & {
  /**
   * The maximum number of tickers to return.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * The page token for pagination.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * The filter for querying tickers.
   *
   * @generated from field: string filter = 3;
   */
  filter: string;

  /**
   * Sorting order: "actionability" (default) | "symbol" | "added"
   *
   * @generated from field: string order_by = 4;
   */
  orderBy: string;

  /**
   * Sort direction: "asc" (ascending) | "desc" (descending, default)
   *
   * @generated from field: string order_direction = 8;
   */
  orderDirection: string;

  /**
   * Only show tickers where |% to buy| or |% to sell| < 10%
   *
   * @generated from field: bool filter_actionable = 5;
   */
  filterActionable: boolean;

  /**
   * Only show tickers with status = 'holding'
   *
   * @generated from field: bool filter_holding = 6;
   */
  filterHolding: boolean;

  /**
   * Only show tickers that have buy/sell targets set
   *
   * @generated from field: bool filter_valued = 7;
   */
  filterValued: boolean;

  /**
   * v0.77.0: Optional watchlist ID to filter tickers by watchlist
   * When set, only returns tickers in the specified watchlist
   * Empty string means return all tickers (no watchlist filter)
   *
   * @generated from field: string watchlist_id = 9;
   */
  watchlistId: string;
};

/**
 * Describes the message journal.api.v1.ListTickersRequest.
 * Use `create(ListTickersRequestSchema)` to create a new message.
 */
export const ListTickersRequestSchema: GenMessage<ListTickersRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 2);

/**
 * @generated from message journal.api.v1.ListTickersResponse
 */
export type ListTickersResponse = Message<"journal.api.v1.ListTickersResponse"> & {
  /**
   * The list of tickers.
   *
   * @generated from field: repeated journal.api.v1.Ticker tickers = 1;
   */
  tickers: Ticker[];

  /**
   * The next page token for pagination.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of tickers matching the filter (for pagination display)
   * v0.71.0: Added to support traditional pagination UI
   *
   * @generated from field: int32 total_size = 3;
   */
  totalSize: number;

  /**
   * Total number of pages (for pagination display)
   * v0.76.0: Added to eliminate frontend dependency on page size constant
   *
   * @generated from field: int32 total_pages = 4;
   */
  totalPages: number;
};

/**
 * Describes the message journal.api.v1.ListTickersResponse.
 * Use `create(ListTickersResponseSchema)` to create a new message.
 */
export const ListTickersResponseSchema: GenMessage<ListTickersResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 3);

/**
 * @generated from message journal.api.v1.GetTickerRequest
 */
export type GetTickerRequest = Message<"journal.api.v1.GetTickerRequest"> & {
  /**
   * The resource name of the ticker.
   * Format: tickers/{symbol}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Whether to include AI analysis in the response (default: false)
   *
   * @generated from field: bool include_ai_analysis = 2;
   */
  includeAiAnalysis: boolean;
};

/**
 * Describes the message journal.api.v1.GetTickerRequest.
 * Use `create(GetTickerRequestSchema)` to create a new message.
 */
export const GetTickerRequestSchema: GenMessage<GetTickerRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 4);

/**
 * @generated from message journal.api.v1.GetTickerResponse
 */
export type GetTickerResponse = Message<"journal.api.v1.GetTickerResponse"> & {
  /**
   * The ticker.
   *
   * @generated from field: journal.api.v1.Ticker ticker = 1;
   */
  ticker?: Ticker;

  /**
   * The associated memos.
   *
   * @generated from field: repeated journal.api.v1.Memo memos = 2;
   */
  memos: Memo[];

  /**
   * The AI analysis result (if requested and available)
   *
   * @generated from field: journal.api.v1.TickerAIAnalysis ai_analysis = 3;
   */
  aiAnalysis?: TickerAIAnalysis;
};

/**
 * Describes the message journal.api.v1.GetTickerResponse.
 * Use `create(GetTickerResponseSchema)` to create a new message.
 */
export const GetTickerResponseSchema: GenMessage<GetTickerResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 5);

/**
 * TickerAIAnalysis represents AI-powered valuation analysis
 *
 * @generated from message journal.api.v1.TickerAIAnalysis
 */
export type TickerAIAnalysis = Message<"journal.api.v1.TickerAIAnalysis"> & {
  /**
   * When the analysis was performed
   *
   * @generated from field: int64 analyzed_at = 1;
   */
  analyzedAt: bigint;

  /**
   * Number of memos analyzed
   *
   * @generated from field: int32 memo_count = 2;
   */
  memoCount: number;

  /**
   * Time range in days
   *
   * @generated from field: int32 time_range_days = 3;
   */
  timeRangeDays: number;

  /**
   * Overall sentiment: bearish | neutral | bullish | strong_bullish | strong_bearish
   *
   * @generated from field: string overall_sentiment = 4;
   */
  overallSentiment: string;

  /**
   * Sentiment score (0.0 to 1.0)
   *
   * @generated from field: float sentiment_score = 5;
   */
  sentimentScore: number;

  /**
   * Valuation impact percentage (-20.0 to +20.0)
   *
   * @generated from field: float valuation_impact = 6;
   */
  valuationImpact: number;

  /**
   * Recommended price low
   *
   * @generated from field: float price_low = 7;
   */
  priceLow: number;

  /**
   * Recommended price high
   *
   * @generated from field: float price_high = 8;
   */
  priceHigh: number;

  /**
   * Fair value estimate
   *
   * @generated from field: float fair_value = 9;
   */
  fairValue: number;

  /**
   * Detailed analysis content (JSON string)
   *
   * @generated from field: string analysis_content = 10;
   */
  analysisContent: string;

  /**
   * LLM model used
   *
   * @generated from field: string llm_model = 11;
   */
  llmModel: string;

  /**
   * LLM response latency in milliseconds
   *
   * @generated from field: int32 latency_ms = 12;
   */
  latencyMs: number;
};

/**
 * Describes the message journal.api.v1.TickerAIAnalysis.
 * Use `create(TickerAIAnalysisSchema)` to create a new message.
 */
export const TickerAIAnalysisSchema: GenMessage<TickerAIAnalysis> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 6);

/**
 * @generated from message journal.api.v1.UpdateTickerRequest
 */
export type UpdateTickerRequest = Message<"journal.api.v1.UpdateTickerRequest"> & {
  /**
   * The ticker to update.
   * The ticker name and other immutable fields cannot be changed.
   *
   * @generated from field: journal.api.v1.Ticker ticker = 1;
   */
  ticker?: Ticker;

  /**
   * The update mask.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateTickerRequest.
 * Use `create(UpdateTickerRequestSchema)` to create a new message.
 */
export const UpdateTickerRequestSchema: GenMessage<UpdateTickerRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 7);

/**
 * @generated from message journal.api.v1.DeleteTickerRequest
 */
export type DeleteTickerRequest = Message<"journal.api.v1.DeleteTickerRequest"> & {
  /**
   * The resource name of the ticker to delete.
   * Format: tickers/{symbol}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteTickerRequest.
 * Use `create(DeleteTickerRequestSchema)` to create a new message.
 */
export const DeleteTickerRequestSchema: GenMessage<DeleteTickerRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 8);

/**
 * @generated from message journal.api.v1.EnrichTickerRequest
 */
export type EnrichTickerRequest = Message<"journal.api.v1.EnrichTickerRequest"> & {
  /**
   * The resource name of the ticker to enrich.
   * Format: tickers/{symbol}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Whether to force re-enrichment even if fields are already present (default: false)
   * When set to true, will overwrite existing fields with fresh data from StockAPI
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message journal.api.v1.EnrichTickerRequest.
 * Use `create(EnrichTickerRequestSchema)` to create a new message.
 */
export const EnrichTickerRequestSchema: GenMessage<EnrichTickerRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 9);

/**
 * @generated from message journal.api.v1.SearchTickersRequest
 */
export type SearchTickersRequest = Message<"journal.api.v1.SearchTickersRequest"> & {
  /**
   * The search query (ticker symbol or company name)
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * The maximum number of results to return (default: 10, max: 100)
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * Whether to include user's tickers in the response (default: true)
   * When enabled, returns two sections: user_tickers (current user's tickers) and master_tickers ( ticker_master results)
   *
   * @generated from field: bool include_user_tickers = 3;
   */
  includeUserTickers: boolean;
};

/**
 * Describes the message journal.api.v1.SearchTickersRequest.
 * Use `create(SearchTickersRequestSchema)` to create a new message.
 */
export const SearchTickersRequestSchema: GenMessage<SearchTickersRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 10);

/**
 * @generated from message journal.api.v1.SearchTickersResponse
 */
export type SearchTickersResponse = Message<"journal.api.v1.SearchTickersResponse"> & {
  /**
   * User's tickers matching the search query (filtered by current user)
   * This is only populated when include_user_tickers = true in the request
   *
   * @generated from field: repeated journal.api.v1.Ticker user_tickers = 1;
   */
  userTickers: Ticker[];

  /**
   * Ticker master results matching the search query (global, no user filter)
   * Contains results from ticker_master table for stocks not yet added by the user
   *
   * @generated from field: repeated journal.api.v1.TickerMasterItem master_tickers = 2;
   */
  masterTickers: TickerMasterItem[];
};

/**
 * Describes the message journal.api.v1.SearchTickersResponse.
 * Use `create(SearchTickersResponseSchema)` to create a new message.
 */
export const SearchTickersResponseSchema: GenMessage<SearchTickersResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 11);

/**
 * TickerMasterItem represents a simplified ticker for search results
 *
 * @generated from message journal.api.v1.TickerMasterItem
 */
export type TickerMasterItem = Message<"journal.api.v1.TickerMasterItem"> & {
  /**
   * The stock symbol (e.g., TSLA, AAPL, GOOGL)
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * The company name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * The exchange where the stock is listed (e.g., NASDAQ, NYSE)
   *
   * @generated from field: string exchange = 3;
   */
  exchange: string;

  /**
   * The type (e.g., stock, etf, index)
   *
   * @generated from field: string type = 4;
   */
  type: string;
};

/**
 * Describes the message journal.api.v1.TickerMasterItem.
 * Use `create(TickerMasterItemSchema)` to create a new message.
 */
export const TickerMasterItemSchema: GenMessage<TickerMasterItem> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 12);

/**
 * LastMemoInfo represents a summary of the last associated memo
 *
 * @generated from message journal.api.v1.LastMemoInfo
 */
export type LastMemoInfo = Message<"journal.api.v1.LastMemoInfo"> & {
  /**
   * The memo ID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The memo UID
   *
   * @generated from field: string uid = 2;
   */
  uid: string;

  /**
   * A short summary of the memo content (first ~100 chars)
   *
   * @generated from field: string summary = 3;
   */
  summary: string;

  /**
   * When the memo was created
   *
   * @generated from field: int64 created_time = 4;
   */
  createdTime: bigint;
};

/**
 * Describes the message journal.api.v1.LastMemoInfo.
 * Use `create(LastMemoInfoSchema)` to create a new message.
 */
export const LastMemoInfoSchema: GenMessage<LastMemoInfo> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 13);

/**
 * PricePoint represents a single historical price point
 *
 * @generated from message journal.api.v1.PricePoint
 */
export type PricePoint = Message<"journal.api.v1.PricePoint"> & {
  /**
   * Unix timestamp
   *
   * @generated from field: int64 date_unix = 1;
   */
  dateUnix: bigint;

  /**
   * @generated from field: float open = 2;
   */
  open: number;

  /**
   * @generated from field: float high = 3;
   */
  high: number;

  /**
   * @generated from field: float low = 4;
   */
  low: number;

  /**
   * @generated from field: float close = 5;
   */
  close: number;

  /**
   * @generated from field: int64 volume = 6;
   */
  volume: bigint;

  /**
   * @generated from field: float adjusted_close = 7;
   */
  adjustedClose: number;

  /**
   * Human-readable date label
   *
   * @generated from field: optional string label = 8;
   */
  label?: string;

  /**
   * @generated from field: optional float change = 9;
   */
  change?: number;

  /**
   * @generated from field: optional float change_percent = 10;
   */
  changePercent?: number;
};

/**
 * Describes the message journal.api.v1.PricePoint.
 * Use `create(PricePointSchema)` to create a new message.
 */
export const PricePointSchema: GenMessage<PricePoint> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 14);

/**
 * GetTickerPriceRequest requests historical price data
 *
 * @generated from message journal.api.v1.GetTickerPriceRequest
 */
export type GetTickerPriceRequest = Message<"journal.api.v1.GetTickerPriceRequest"> & {
  /**
   * The ticker symbol (required)
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * Time range: one of "1m", "3m", "6m", "YTD", "1y", "3y", "5y" (default: "1y")
   *
   * @generated from field: string time_range = 2;
   */
  timeRange: string;
};

/**
 * Describes the message journal.api.v1.GetTickerPriceRequest.
 * Use `create(GetTickerPriceRequestSchema)` to create a new message.
 */
export const GetTickerPriceRequestSchema: GenMessage<GetTickerPriceRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 15);

/**
 * GetTickerPriceResponse contains historical price data
 *
 * @generated from message journal.api.v1.GetTickerPriceResponse
 */
export type GetTickerPriceResponse = Message<"journal.api.v1.GetTickerPriceResponse"> & {
  /**
   * List of price points
   *
   * @generated from field: repeated journal.api.v1.PricePoint prices = 1;
   */
  prices: PricePoint[];

  /**
   * Current/latest price point
   *
   * @generated from field: journal.api.v1.PricePoint current_price = 2;
   */
  currentPrice?: PricePoint;

  /**
   * Price change over the time range
   *
   * @generated from field: float change = 3;
   */
  change: number;

  /**
   * Price change percentage over the time range
   *
   * @generated from field: float change_percent = 4;
   */
  changePercent: number;

  /**
   * Currency (e.g., "USD")
   *
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * Optional data range metadata
   *
   * @generated from field: optional int64 data_start_date = 6;
   */
  dataStartDate?: bigint;

  /**
   * @generated from field: optional int64 data_end_date = 7;
   */
  dataEndDate?: bigint;
};

/**
 * Describes the message journal.api.v1.GetTickerPriceResponse.
 * Use `create(GetTickerPriceResponseSchema)` to create a new message.
 */
export const GetTickerPriceResponseSchema: GenMessage<GetTickerPriceResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 16);

/**
 * GetMarketStatusRequest requests market status
 *
 * @generated from message journal.api.v1.GetMarketStatusRequest
 */
export type GetMarketStatusRequest = Message<"journal.api.v1.GetMarketStatusRequest"> & {
  /**
   * Market identifier (default: "US")
   * Options: "US", "NYSE", "NASDAQ"
   *
   * @generated from field: string market = 1;
   */
  market: string;
};

/**
 * Describes the message journal.api.v1.GetMarketStatusRequest.
 * Use `create(GetMarketStatusRequestSchema)` to create a new message.
 */
export const GetMarketStatusRequestSchema: GenMessage<GetMarketStatusRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 17);

/**
 * GetMarketStatusResponse contains market status
 *
 * @generated from message journal.api.v1.GetMarketStatusResponse
 */
export type GetMarketStatusResponse = Message<"journal.api.v1.GetMarketStatusResponse"> & {
  /**
   * Market identifier
   *
   * @generated from field: string market = 1;
   */
  market: string;

  /**
   * Whether the market is currently open
   *
   * @generated from field: bool is_open = 2;
   */
  isOpen: boolean;

  /**
   * Current time in market timezone
   *
   * @generated from field: string current_time = 3;
   */
  currentTime: string;

  /**
   * Next market open time (if available)
   *
   * @generated from field: string next_open_time = 4;
   */
  nextOpenTime: string;

  /**
   * Next market close time (if available)
   *
   * @generated from field: string next_close_time = 5;
   */
  nextCloseTime: string;

  /**
   * Timezone (e.g., "America/New_York")
   *
   * @generated from field: string timezone = 6;
   */
  timezone: string;
};

/**
 * Describes the message journal.api.v1.GetMarketStatusResponse.
 * Use `create(GetMarketStatusResponseSchema)` to create a new message.
 */
export const GetMarketStatusResponseSchema: GenMessage<GetMarketStatusResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 18);

/**
 * GetHolidaysRequest requests holidays for a market
 *
 * @generated from message journal.api.v1.GetHolidaysRequest
 */
export type GetHolidaysRequest = Message<"journal.api.v1.GetHolidaysRequest"> & {
  /**
   * Market identifier (default: "US")
   *
   * @generated from field: string market = 1;
   */
  market: string;

  /**
   * Year to get holidays for (default: current year)
   * If 0, return holidays for all available years
   *
   * @generated from field: int32 year = 2;
   */
  year: number;
};

/**
 * Describes the message journal.api.v1.GetHolidaysRequest.
 * Use `create(GetHolidaysRequestSchema)` to create a new message.
 */
export const GetHolidaysRequestSchema: GenMessage<GetHolidaysRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 19);

/**
 * Holiday represents a market holiday
 *
 * @generated from message journal.api.v1.Holiday
 */
export type Holiday = Message<"journal.api.v1.Holiday"> & {
  /**
   * Holiday name
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Date in YYYY-MM-DD format
   *
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * Trading hours modification (e.g., "09:30-13:00")
   *
   * @generated from field: string trading_hour = 3;
   */
  tradingHour: string;

  /**
   * Post-market hours modification
   *
   * @generated from field: string post_market = 4;
   */
  postMarket: string;
};

/**
 * Describes the message journal.api.v1.Holiday.
 * Use `create(HolidaySchema)` to create a new message.
 */
export const HolidaySchema: GenMessage<Holiday> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 20);

/**
 * GetHolidaysResponse contains holidays list
 *
 * @generated from message journal.api.v1.GetHolidaysResponse
 */
export type GetHolidaysResponse = Message<"journal.api.v1.GetHolidaysResponse"> & {
  /**
   * List of holidays
   *
   * @generated from field: repeated journal.api.v1.Holiday holidays = 1;
   */
  holidays: Holiday[];

  /**
   * Market identifier
   *
   * @generated from field: string market = 2;
   */
  market: string;

  /**
   * Year (if specified in request)
   *
   * @generated from field: optional int32 year = 3;
   */
  year?: number;

  /**
   * Timezone
   *
   * @generated from field: string timezone = 4;
   */
  timezone: string;
};

/**
 * Describes the message journal.api.v1.GetHolidaysResponse.
 * Use `create(GetHolidaysResponseSchema)` to create a new message.
 */
export const GetHolidaysResponseSchema: GenMessage<GetHolidaysResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 21);

/**
 * GetQuoteRequest requests a real-time quote
 *
 * @generated from message journal.api.v1.GetQuoteRequest
 */
export type GetQuoteRequest = Message<"journal.api.v1.GetQuoteRequest"> & {
  /**
   * The ticker symbol (required)
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;
};

/**
 * Describes the message journal.api.v1.GetQuoteRequest.
 * Use `create(GetQuoteRequestSchema)` to create a new message.
 */
export const GetQuoteRequestSchema: GenMessage<GetQuoteRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 22);

/**
 * GetQuoteResponse contains real-time quote data
 *
 * @generated from message journal.api.v1.GetQuoteResponse
 */
export type GetQuoteResponse = Message<"journal.api.v1.GetQuoteResponse"> & {
  /**
   * The ticker symbol
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * Current price
   *
   * @generated from field: double current_price = 2;
   */
  currentPrice: number;

  /**
   * Price change from previous close
   *
   * @generated from field: double change = 3;
   */
  change: number;

  /**
   * Percent change
   *
   * @generated from field: double percent_change = 4;
   */
  percentChange: number;

  /**
   * High price of the day
   *
   * @generated from field: double high = 5;
   */
  high: number;

  /**
   * Low price of the day
   *
   * @generated from field: double low = 6;
   */
  low: number;

  /**
   * Open price of the day
   *
   * @generated from field: double open = 7;
   */
  open: number;

  /**
   * Previous close price
   *
   * @generated from field: double previous_close = 8;
   */
  previousClose: number;

  /**
   * Timestamp
   *
   * @generated from field: int64 timestamp = 9;
   */
  timestamp: bigint;

  /**
   * Currency
   *
   * @generated from field: string currency = 10;
   */
  currency: string;
};

/**
 * Describes the message journal.api.v1.GetQuoteResponse.
 * Use `create(GetQuoteResponseSchema)` to create a new message.
 */
export const GetQuoteResponseSchema: GenMessage<GetQuoteResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 23);

/**
 * ListTickerSymbolsRequest lists lightweight ticker symbols for auto-completion
 * v0.71.0: Lightweight endpoint for editor suggestions (symbol + name only)
 *
 * @generated from message journal.api.v1.ListTickerSymbolsRequest
 */
export type ListTickerSymbolsRequest = Message<"journal.api.v1.ListTickerSymbolsRequest"> & {
  /**
   * Only return user's tickers (default: false returns all tickers from ticker_master)
   *
   * @generated from field: bool user_tickers_only = 1;
   */
  userTickersOnly: boolean;

  /**
   * Maximum number of results to return (default: 500, max: 1000)
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message journal.api.v1.ListTickerSymbolsRequest.
 * Use `create(ListTickerSymbolsRequestSchema)` to create a new message.
 */
export const ListTickerSymbolsRequestSchema: GenMessage<ListTickerSymbolsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 24);

/**
 * ListTickerSymbolsResponse contains lightweight ticker information
 *
 * @generated from message journal.api.v1.ListTickerSymbolsResponse
 */
export type ListTickerSymbolsResponse = Message<"journal.api.v1.ListTickerSymbolsResponse"> & {
  /**
   * Lightweight ticker symbols (symbol + name only)
   *
   * @generated from field: repeated journal.api.v1.TickerSymbolItem symbols = 1;
   */
  symbols: TickerSymbolItem[];
};

/**
 * Describes the message journal.api.v1.ListTickerSymbolsResponse.
 * Use `create(ListTickerSymbolsResponseSchema)` to create a new message.
 */
export const ListTickerSymbolsResponseSchema: GenMessage<ListTickerSymbolsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 25);

/**
 * TickerSymbolItem represents a lightweight ticker for auto-completion
 *
 * @generated from message journal.api.v1.TickerSymbolItem
 */
export type TickerSymbolItem = Message<"journal.api.v1.TickerSymbolItem"> & {
  /**
   * The stock symbol (e.g., TSLA, AAPL, GOOGL)
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * The company name
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message journal.api.v1.TickerSymbolItem.
 * Use `create(TickerSymbolItemSchema)` to create a new message.
 */
export const TickerSymbolItemSchema: GenMessage<TickerSymbolItem> = /*@__PURE__*/
  messageDesc(file_api_v1_ticker_service, 26);

/**
 * @generated from service journal.api.v1.TickerService
 */
export const TickerService: GenService<{
  /**
   * CreateTicker creates a new ticker by syncing from FMP API
   *
   * @generated from rpc journal.api.v1.TickerService.CreateTicker
   */
  createTicker: {
    methodKind: "unary";
    input: typeof CreateTickerRequestSchema;
    output: typeof TickerSchema;
  },
  /**
   * ListTickers lists all tickers with pagination
   *
   * @generated from rpc journal.api.v1.TickerService.ListTickers
   */
  listTickers: {
    methodKind: "unary";
    input: typeof ListTickersRequestSchema;
    output: typeof ListTickersResponseSchema;
  },
  /**
   * GetTicker gets a ticker by resource name with associated memos
   *
   * @generated from rpc journal.api.v1.TickerService.GetTicker
   */
  getTicker: {
    methodKind: "unary";
    input: typeof GetTickerRequestSchema;
    output: typeof GetTickerResponseSchema;
  },
  /**
   * UpdateTicker updates a ticker
   *
   * @generated from rpc journal.api.v1.TickerService.UpdateTicker
   */
  updateTicker: {
    methodKind: "unary";
    input: typeof UpdateTickerRequestSchema;
    output: typeof TickerSchema;
  },
  /**
   * DeleteTicker deletes a ticker
   *
   * @generated from rpc journal.api.v1.TickerService.DeleteTicker
   */
  deleteTicker: {
    methodKind: "unary";
    input: typeof DeleteTickerRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * EnrichTicker enriches a ticker with missing fields (sector, industry, description, logo)
   * This is useful when a ticker was created with incomplete data (e.g., from ticker_master fallback)
   *
   * @generated from rpc journal.api.v1.TickerService.EnrichTicker
   */
  enrichTicker: {
    methodKind: "unary";
    input: typeof EnrichTickerRequestSchema;
    output: typeof TickerSchema;
  },
  /**
   * SearchTickers searches tickers by symbol or name (for auto-completion)
   *
   * @generated from rpc journal.api.v1.TickerService.SearchTickers
   */
  searchTickers: {
    methodKind: "unary";
    input: typeof SearchTickersRequestSchema;
    output: typeof SearchTickersResponseSchema;
  },
  /**
   * GetTickerPrice gets historical price data for a ticker with time range filtering
   *
   * @generated from rpc journal.api.v1.TickerService.GetTickerPrice
   */
  getTickerPrice: {
    methodKind: "unary";
    input: typeof GetTickerPriceRequestSchema;
    output: typeof GetTickerPriceResponseSchema;
  },
  /**
   * GetMarketStatus gets the current market status (open/closed)
   *
   * @generated from rpc journal.api.v1.TickerService.GetMarketStatus
   */
  getMarketStatus: {
    methodKind: "unary";
    input: typeof GetMarketStatusRequestSchema;
    output: typeof GetMarketStatusResponseSchema;
  },
  /**
   * GetHolidays gets holidays for a market in a specific year
   *
   * @generated from rpc journal.api.v1.TickerService.GetHolidays
   */
  getHolidays: {
    methodKind: "unary";
    input: typeof GetHolidaysRequestSchema;
    output: typeof GetHolidaysResponseSchema;
  },
  /**
   * GetQuote gets a real-time quote for a ticker (uses Finnhub)
   *
   * @generated from rpc journal.api.v1.TickerService.GetQuote
   */
  getQuote: {
    methodKind: "unary";
    input: typeof GetQuoteRequestSchema;
    output: typeof GetQuoteResponseSchema;
  },
  /**
   * ListTickerSymbols lists lightweight ticker symbols for auto-completion
   * v0.71.0: Lightweight endpoint for editor suggestions (symbol + name only)
   *
   * @generated from rpc journal.api.v1.TickerService.ListTickerSymbols
   */
  listTickerSymbols: {
    methodKind: "unary";
    input: typeof ListTickerSymbolsRequestSchema;
    output: typeof ListTickerSymbolsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_ticker_service, 0);

